<template>
  <div class="Table2Charts">
    <div class="no-data" v-if="noData">
      <sapn>暂无数据！</sapn>
    </div>

    <div v-else class="scroll_table" :class="getStyle('title')">
      <div class="table-header">
        <div class="table-cell" v-for="(item, index) in tableHeader" :key="index">{{ item }}</div>
      </div>
      <!--   @mousewheel="mousewheelFunc" -->
      <vue-seamless-scroll
        :data="tableData"
        class="seamless-warp"
        :style="{ width: '100%', padding: '0 0 0 0px' }"
        :class-option="classOption"
      >
        <div
          class="table-row table_scroll"
          v-for="(item, index) in tableData"
          :key="index"
          :prop="item"
          :ref="'row_' + index"
        >
          <div
            class="table-cell"
            :class="{ 'no-read': item.hasOwnProperty('flag') && item.flag == 0 ? true : false }"
            v-for="(value, key, index) in item.data"
            :key="index"
            @mousedown="!isEditMode && isOpenLink && cellClick(item.id, $event)"
          >
            {{ value }}
          </div>
        </div>
      </vue-seamless-scroll>
    </div>
  </div>
</template>

<script>
import { request } from '../../../../common/request';
import { jumpSomePlaceByLink, getFilterValue } from '../../../../utils/tool';
import { mapState } from 'vuex';
import vueSeamlessScroll from 'vue-seamless-scroll/src';
export default {
  name: 'Table2Charts',
  components: {
    vueSeamlessScroll,
  },
  props: {
    ProjectInfo: Object,
    Configuration: Object,
  },
  data() {
    return {
      style: {
        height: 200,
      },
      tableHeader: ['序号', '名称', '人流量'],
      apiIntervalTaskID: null,
      staticIntervalTaskID: null,
      value: { isShowRightDropDownBox: false },
      params: {}, // 请求参数
      paramsCopy: {},
      noData: false, // 无数据
      // 表格数据
      tableData: [],
      tableProps: [], // 表格属性
      fontStyle: {},
    };
  },
  watch: {
    Configuration: {
      deep: true,
      handler: function() {
        if (this.Configuration.isScaling) {
          this.getfontSize();
          console.log('scale');
        } else if (this.Configuration.isMoving) {
          console.log('mov');
        } else {
          this.debounce_subscribeConfigurationChange();
        }
      },
    },
  },
  computed: {
    ...mapState({ isEditMode: state => state.isEditMode }),
    isOpenLink() {
      return this.Configuration.propertyData?.chartLink?.value?.isOpenLink;
    },
    classOption() {
      return {
        step: 0.4, // 数值越大速度滚动越快
        limitMoveNum: this.tableData.length < 5 ? 5 : this.tableData.length, // length 大于等于5 开始滚动
        hoverStop: true, // 是否开启鼠标悬停stop
        direction: 1, // 0向下 1向上 2向左 3向右
        openWatch: true, // 开启数据实时监控刷新dom
        singleHeight: 0, // 单步运动停止的高度(默认值0是无缝不停止的滚动) direction => 0/1
        singleWidth: 0, // 单步运动停止的宽度(默认值0是无缝不停止的滚动) direction => 2/3
        waitTime: 1000, // 单步运动停止的时间(默认值1000ms)
        openTouch: true,
      };
    },
  },
  created() {
    clearInterval(this.apiIntervalTaskID);
    clearInterval(this.staticIntervalTaskID);
    clearInterval(this.staticIntervalTaskID2);
    this.registerDebounceAndThrottle();
  },
  mounted() {
    this.$nextTick(() => {
      this.startApiIntervalTask();
      this.startStaticIntervalTask();
    });
    this.getApiDataResByFilterAndResponseQuery();
    // 默认取api参数
    let that = this;
    let ChartsData = this.Configuration?.propertyData?.ChartsData?.value;
    let params = ChartsData?.apiData?.apiPostParams || '{}';
    this.params = eval('(' + params + ')');
    console.log(this.params, 'aaaaaaaaa');
    this.paramsCopy = eval('(' + params + ')');
  },

  beforeUnmount() {
    clearInterval(this.apiIntervalTaskID);
    clearInterval(this.staticIntervalTaskID);
    clearInterval(this.staticIntervalTaskID2);
    this.unRegisterDebounceAndThrottle();
  },
  methods: {
    cellClick(id = '', e) {
      console.log('测试点击');
      e.stopPropagation();
      let type = this.Configuration.propertyData.chartLink.value.linkType;
      let url = this.Configuration.propertyData.chartLink.value.linkUrl;
      if (id != '') {
        console.log(url + '' + id);
        window.open(url + '' + id, '_blank');
      } else {
        // jumpSomePlaceByLink(type, url)
      }
    },
    echartClick(id = '') {
      e.stopPropagation();
      let type = this.Configuration.propertyData.chartLink.value.linkType;
      let url = this.Configuration.propertyData.chartLink.value.linkUrl;
      if (id != '') {
        window.open(url + '' + id, '_blank');
      } else {
        jumpSomePlaceByLink(type, url);
      }
    },
    getShowfontSizeBase() {
      return Math.round(this.Configuration.style.height / 20);
    },
    getStyle(e = '') {
      let style = {};
      let bool = e == 'title';
      switch (this.style) {
        case 'V1Style':
          style = {};
          if (bool) style['V1StyleTitle'] = true;
          style['V1Style'] = true;
          break;
        case 'V2Style':
          style = {};
          if (bool) style['V2StyleTitle'] = true;
          style['V2Style'] = true;
          break;
        case 'V3Style':
          style = {};
          if (bool) style['V3StyleTitle'] = true;
          style['V3Style'] = true;
          break;
        case 'V4Style':
          style = {};
          if (bool) style['V4StyleTitle'] = true;
          style['V4Style'] = true;
          break;
        case 'V5Style':
          style = {};
          if (bool) style['V5StyleTitle'] = true;
          style['V5Style'] = true;
          break;
        case 'V6Style':
          style = {};
          if (bool) style['V6StyleTitle'] = true;
          style['V6Style'] = true;
          break;
        case 'V7Style':
          style = {};
          if (bool) style['V7StyleTitle'] = true;
          style['V7Style'] = true;
          break;
        case 'V8Style':
          if (bool) style['V8StyleTitle'] = true;
          style['V8Style'] = true;
          break;
        case 'V9Style':
          if (bool) style['V9StyleTitle'] = true;
          style['V9Style'] = true;
          break;
        case 'V11Style':
          if (bool) style['V11StyleTitle'] = true;
          style['V11Style'] = true;
          break;
        default:
          break;
      }
      return style;
    },
    getFilterValue(e) {
      return getFilterValue(e);
    },
    getfontSize() {
      return {
        'font-size': this.fontStyle.yAxisSize + 'px',
        height: this.Configuration.style.height + 'px',
      };
    },
    registerDebounceAndThrottle() {
      this.debounce_subscribeConfigurationChange = this.$_.debounce(this.subscribeConfigurationChange, 500);
    },
    unRegisterDebounceAndThrottle() {
      this.debounce_subscribeConfigurationChange.cancel();
    },
    // 订阅Configuration变化将会执行的函数
    subscribeConfigurationChange() {
      clearInterval(this.apiIntervalTaskID);
      clearInterval(this.staticIntervalTaskID);
      clearInterval(this.staticIntervalTaskID2);
      this.startApiIntervalTask();
      this.startStaticIntervalTask();
    },
    setEchartsOptions(ParamData = null) {
      if (Object.keys(ParamData).length == 0 || ParamData.source.length == 0) {
        this.noData = true;
      } else {
        this.noData = false;
      }
      let grid = {};
      let source = [];
      let seriesList = [];
      let fontStyle = {
        titleColor: '#ccc',
        titleSize: 16,
        xAxisColor: '#c3dbff',
        xAxisSize: 12,
        yAxisColor: '#c3dbff',
        yAxisSize: 12,
      };
      let tableProps = [];
      if (this.Configuration.propertyData.chartsGrid.value) {
        grid = this.Configuration.propertyData.chartsGrid.value;
      }
      if (ParamData && ParamData.source && ParamData.seriesList) {
        source = ParamData.source;
        seriesList = ParamData.seriesList;
        if (tableProps) {
          this.tableProps = tableProps;
        }
      }
      if (this.Configuration.propertyData.fontStyle.value) {
        fontStyle = this.Configuration.propertyData.fontStyle.value;
      }
      if (this.Configuration.propertyData?.chartsRightDropDown?.value) {
        this.value = this.Configuration.propertyData.chartsRightDropDown.value;
      }

      let propData = [];
      let tableData = [];

      source.forEach(item => {
        propData.push(item.x);
      });
      this.tableHeader = [...new Set(propData)];
      function DealData() {
        seriesList.forEach(s => {
          let obj = {
            // flag: '',
            data: {},
          };
          source.forEach(item => {
            if (item.s === s) {
              obj.data[item.x] = item.y;
              // 如果有z属性，就添加
              if (item.hasOwnProperty('z')) {
                obj['flag'] = item.z;
              }
              if (item.hasOwnProperty('id')) {
                obj['id'] = item.id;
              }
            }
          });
          tableData.push(obj);
        });
      }
      DealData();
      this.tableData = tableData;
      // console.log(this.tableData, 'tableData');
    },
    // 开启静态任务 数据是静态的
    startStaticIntervalTask() {
      let ChartsData = this.Configuration?.propertyData?.ChartsData?.value;
      let chartsAnimation = this.Configuration?.propertyData?.chartsAnimation?.value;
      if (ChartsData?.currenEntry === 'staticData' && chartsAnimation?.isUseStaticRefresh) {
        // console.log('使用静态任务');
        let func = () => {
          this.setEchartsOptions(ChartsData.staticData);
          this.$nextTick(() => {
            // this.createEcharts();
          });
        };
        func();
        this.staticIntervalTaskID = setInterval(() => {
          func();
        }, chartsAnimation?.staticRefreshIntervalTime * 1000);
      } else if (ChartsData?.currenEntry === 'staticData') {
        this.setEchartsOptions(ChartsData.staticData);
        this.$nextTick(() => {
          // this.createEcharts();
        });
      }
    },
    // 开启api动态任务 数据是动态的
    async startApiIntervalTask() {
      let ChartsData = this.Configuration?.propertyData?.ChartsData?.value;
      // 判断是否使用apiData，使用动态interval请求
      if (ChartsData?.currenEntry === 'apiData' && ChartsData?.apiData?.isUseInterval) {
        // 开启interval任务 间隔请求
        let func = async () => {
          let res = await this.getApiDataResByFilterAndResponseQuery();
          if (res == undefined) {
            res = {};
            this.setEchartsOptions(res);
            this.$nextTick(() => {
              // this.createEcharts();
            });
          } else {
            this.setEchartsOptions(res);
            this.$nextTick(() => {
              // this.createEcharts();
            });
          }
        };
        func();
        this.apiIntervalTaskID = setInterval(async () => {
          // console.log('开启interval任务 间隔请求');
          func();
        }, ChartsData?.apiData?.apiInterval * 1000);
      } else if (ChartsData?.currenEntry === 'apiData') {
        let res = await this.getApiDataResByFilterAndResponseQuery();
        this.setEchartsOptions(res);
        this.$nextTick(() => {
          // this.createEcharts();
        });
      }
    },
    // promise 返回api链接的请求数据
    getApiDataRes() {
      let ChartsData = this.Configuration?.propertyData?.ChartsData?.value;
      let that = this;
      return new Promise((resolve, reject) => {
        if (!ChartsData) resolve('Error ChartsData 不存在！');
        if (!ChartsData.apiData?.apiUrl) resolve('Error apiUrl 不存在！');
        let header;
        if (ChartsData.apiData?.isUseUserKey) {
          let user_key = localStorage.getItem('user_key');

          if (user_key == 'undefined' || user_key == 'null' || user_key == null) user_key = this.$userKey;
          header = {
            userkey: user_key,
          };
        } else {
          header = {};
        }
        if (ChartsData.apiData?.apiUrlMethod == 'get') {
          let param = {
            method: ChartsData.apiData.apiUrlMethod,
            url: ChartsData.apiData.apiUrl,
            params: this.params,
            headers: header,
          };
          request(param)
            .then(res => {
              let data = this.$_.cloneDeep(res);
              resolve(data);
            })
            .catch(err => {
              reject(err);
            });
        } else {
          let params = ChartsData.apiData.apiPostParams || {};
          let param = {
            method: ChartsData.apiData.apiUrlMethod,
            url: ChartsData.apiData.apiUrl,
            params: this.params,
            headers: header,
          };

          request(param)
            .then(res => {
              let data = this.$_.cloneDeep(res);
              resolve(data);
            })
            .catch(err => {
              reject(err);
            });
        }
      });
    },
    // promise 返回api链接的请求数据 使用ResponseQuery
    getApiDataResByResponseQuery() {
      return new Promise((resolve, reject) => {
        let ChartsData = this.Configuration?.propertyData?.ChartsData?.value;
        if (!ChartsData) reject('Error ChartsData 不存在！');
        this.getApiDataRes()
          .then(res => {
            // query数据
            let arryQuery = ChartsData.apiData.apiResponseQuery.split('.');
            if (arryQuery.length >= 1) {
              arryQuery.forEach(item => {
                res = res[item];
              });
            }
            console.log('getApiDataResByResponseQuery');
            console.log(res);
            let data = this.$_.cloneDeep(res);
            resolve(data);
          })
          .catch(error => {
            reject(error);
          });
      });
    },
    // promise 返回api链接的请求数据 使用ResponseQuery和过滤器函数
    getApiDataResByFilterAndResponseQuery() {
      return new Promise((resolve, reject) => {
        let ChartsData = this.Configuration?.propertyData?.ChartsData?.value;
        if (!ChartsData) reject('Error ChartsData 不存在！');
        let filter = function(data, filter_text) {
          if (data != null) {
            let dataSet = {};
            eval(filter_text);
            return dataSet;
          }
        };
        this.getApiDataRes()
          .then(res => {
            // query数据
            let arryQuery = ChartsData.apiData.apiResponseQuery.split('.');
            if (arryQuery.length >= 1) {
              arryQuery.forEach(item => {
                res = res[item];
              });
            }
            // 判断是否使用过滤器
            if (ChartsData.apiData.isUseFilter) {
              res = filter(res, ChartsData.apiData.apiFilter);
            }
            console.log(res, 'getApiDataResByFilterAndResponseQuery');
            let data = this.$_.cloneDeep(res);
            resolve(data);
          })
          .catch(error => {
            reject(error);
          });
      });
    },
  },
  Configuration: {
    componentTitle: '动态表格',
    componentName: 'Table2Charts',
    componentOverViewImg: './img/charts/TableCharts/Table2Charts.png',
    id: '',
    style: {
      width: 400,
      height: 200,
      left: 0,
      top: 0,
    },
    isScaling: false,
    isMoving: false,
    propertyData: {
      titleText: {
        value: '图表标题',
        lable: '图表标题',
        propertyComponentName: 'SingleInputor',
      },
      borderConfig: {
        propertyComponentName: 'ChartsBorderConfiger',
        value: {
          borderComponentName: 'Charts1Border',
        },
      },
      ChartsData: {
        lable: '数据接入',
        propertyComponentName: 'ChartsDataConfigor',
        value: {
          currenEntry: 'staticData',
          apiData: {
            apiUrl:
              'https://restapi.amap.com/v3/weather/weatherInfo?city=%E6%9D%AD%E5%B7%9E&output=json&key=db5d2728c584e5884c385c2a509b29b9&extensions=all',
            // apiUrl:
            // 'http://192.168.0.173/gthmmc_v4.0/gthmmc/index.php?m=sdms&c=dataMange&a=completeStatisticsdata&data=%7B%22type%22:%22%E6%80%BB%E6%95%B0%22,%22date_start%22:%222021-03-01%22,%22date_end%22:%222021-03-31%22%7D&directory_code=pro_ownerstatistics&type=day',
            apiResponseQuery: 'data.forecasts',
            isUseFilter: true,
            apiFilter: `
          // 可以使用data访问api请求的响应结果
let seriesList = []

let seriesListKey = 'city'
let seriesListChildrenKey = 'casts'

data.forEach((item) => {
  seriesList.push(item[seriesListKey])
})
dataSet.seriesList = seriesList
dataSet.source = []
data.forEach((item) => {
  item[seriesListChildrenKey].forEach(item2 => {
    dataSet.source.push({
      s: item[seriesListKey],
      x: item2.date,
      y: item2.daytemp
    })
  })
})
          `,
            isUseInterval: true,
            apiInterval: 10,
            apiUrlMethod: 'get',
            apiPostParams: '',
          },
          staticData: {
            seriesList: ['1', '2', '3', '4', '5'],
            source: [
              {
                s: '1',
                x: '序号',
                y: '1',
              },
              {
                s: '1',
                x: '名称',
                y: 'xxx',
              },
              {
                s: '1',
                x: '销售额',
                y: '566',
              },
              {
                s: '2',
                x: '序号',
                y: '2',
              },
              {
                s: '2',
                x: '名称',
                y: 'yyy',
              },
              {
                s: '2',
                x: '销售额',
                y: '5669',
              },
              {
                s: '3',
                x: '序号',
                y: '3',
              },
              {
                s: '3',
                x: '名称',
                y: 'ddd',
              },
              {
                s: '3',
                x: '销售额',
                y: '3634',
              },
              {
                s: '4',
                x: '序号',
                y: '4',
              },
              {
                s: '4',
                x: '名称',
                y: 'uuu',
              },
              {
                s: '4',
                x: '销售额',
                y: '8754',
              },
              {
                s: '5',
                x: '序号',
                y: '5',
              },
              {
                s: '5',
                x: '名称',
                y: 'fff',
              },
              {
                s: '5',
                x: '销售额',
                y: '3452',
              },
            ],
          },
        },
      },
      // 链接
      chartLink: {
        propertyComponentName: 'ChartsLinkConfiger',
        value: {
          isOpenLink: false, // 是否开启链接
          linkType: 'inner', // 链接类型 inner内链场景、outer外链地址
          linkUrl: '', // 链接url ，inner时是场景的id、outer时是http地址
        },
      },
      posSize: {
        lable: '位置尺寸',
        propertyComponentName: 'ChartsPosSizeConfiger',
        value: {
          width: 300,
          height: 10,
          left: 0,
          top: 0,
        },
      },
      fontStyle: {
        lable: '图表文字样式',
        propertyComponentName: 'ChartsFontStyleConfiger',
        value: {
          titleSize: 16,
          titleColor: '#ccc',
          xAxisSize: 12,
          xAxisColor: '#c3dbff',
          yAxisSize: 12,
          yAxisColor: '#c3dbff',
        },
      },
      chartsGrid: {
        lable: '图表定位',
        propertyComponentName: 'ChartsGridConfiger',
        value: {
          left: '5%',
          right: '5%',
          bottom: '17%',
          top: '12%',
        },
      },
      showStatus: {
        value: 'norm',
      },
      chartsOpicity: {
        propertyComponentName: 'ChartsOpicityConfiger',
        value: 1,
      },
    },
  },
};
</script>

<style lang="scss" scoped>
.Table2Charts {
  height: 90%;

  .scroll_table {
    height: 100%;
    padding-bottom: 10px;
    background: linear-gradient(
      to top,
      rgba(5, 44, 87, 0.7),
      transparent 20%,
      transparent,
      transparent 80%,
      rgba(5, 44, 87, 0.7) 100%
    );
    border-radius: 2px;
    margin-top: 10px;

    ::v-deep .table .el-table__body-wrapper {
      display: none;
    }

    // 重点注意这段样式
    .seamless-warp {
      height: 80%;
      overflow: hidden;

      ::v-deep .table_scroll .el-table__header-wrapper {
        display: none;
      }
    }
  }

  .table-header {
    display: flex;
    line-height: 35px;
    height: 35px;
    justify-content: space-around;
    transition: all 0.3s;
    color: #589ced;
    font-size: 15px;
    border-bottom: 1px solid #021a3c;

    .table-cell {
      flex: 1;
      text-align: center;
    }
  }

  .table-row {
    display: flex;
    line-height: 35px;
    height: 35px;
    justify-content: space-around;
    transition: all 0.3s;

    .table-cell {
      flex: 1;
      text-align: center;
      font-size: 12px;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
      color: #7996bd;

      &:hover {
        cursor: pointer;
        text-decoration: underline;
      }
    }
  }

  .hidden-row {
    height: 0 !important;
    line-height: 0 !important;
    display: none !important;
  }

  .scroll-wrap {
    animation: scroll 18s linear infinite;
    position: relative;
  }

  .scroll-wrap:hover {
    animation-play-state: paused;
  }

  .table-body {
    overflow-y: hidden;

    .table-row {
      color: #fff;
    }
  }
  .echarts {
    width: 100%;
    height: 100%;
  }
  .no-data {
    width: 100%;
    height: 100%;
    // background: #000;
    position: absolute;
    top: 0;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 14px;
    color: #a9a9a9;
  }
}

.V2Style {
  .scroll_table {
    background: rgba(61, 61, 61, 0.479);
  }

  .table-header {
    border-bottom: 1px solid rgb(124, 124, 124);
  }
  .table-cell {
    color: rgb(236, 236, 236) !important;
  }
}

.V4Style {
  .scroll_table {
    background: rgba(115, 90, 133, 0.24);
  }

  .table-header {
    border-bottom: 1px solid #6a577a;
    font-size: 14px;
  }

  .table-cell {
    color: #bdaaeb !important;
  }
}

.V5Style {
  .scroll_table {
    background: rgba(98, 139, 110, 0.37);
  }
  .table-header {
    border-bottom: 1px solid #87a38291;
    font-size: 14px;
  }

  .table-cell {
    color: #fff;
  }
  .table-row .table-cell {
    color: #fff;
  }
}
.V6Style {
  .table-header {
    font-size: 14px !important;
  }
}

.V8Style {
  .scroll_table {
    background: rgb(255, 255, 255);
  }

  .table-header {
    border-bottom: 1px solid rgb(191 191 191);
  }

  .table-cell {
    color: rgb(37, 37, 37) !important;
  }
}
.V11Style {
  .scroll_table {
    background: linear-gradient(to top, #352106, transparent 68%, transparent, transparent 64%, #352106 100%);
  }
  .table-header {
    color: #fff;
    border-bottom: 1px solid #5b3808;
    line-height: 56px;
    height: 56px;
    font-size: 14px;
  }
  .table-row {
    line-height: 50px;
    height: 50px;
  }
  .table-row .table-cell {
    color: #ffe6c2;
  }
}

.no-read {
  color: #e71c1c !important;
}
@media screen and (max-width: 1400px) {
  .Table2Charts {
    margin-top: 10px;
  }

  .Table2Charts .scroll_table .seamless-warp {
    height: 70% !important;
  }
}
@media screen and (min-width: 3300px) {
  .Table2Charts .table-header {
    font-size: 26px !important;
  }
  .Table2Charts .table-row .table-cell {
    font-size: 22px !important;
  }
}
</style>
